import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
} from '@angular/common/http';
import { finalize, tap } from 'rxjs/operators';

import { Router } from '@angular/router';
import { ApiRoutes } from 'app/routes/app.routes';
import { AppStateManager } from 'app/state/app.state';
import { Observable } from 'rxjs';
import { LoaderService } from 'app/services/loader/loader.service';
import { NotificationService } from 'app/services/notification/notification.service';

@Injectable()
export class ResponseInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private state: AppStateManager,
    private loaderService: LoaderService,
    private notificationsService: NotificationService
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    // this.state.setLoader(true);

    return next.handle(request).pipe(
      tap({
        next: (data) => {
          if (data instanceof HttpResponse) {
            let headings: string[] = [];
            if (!request.url.includes('file')) {
              // if (typeof data?.body?.data && data.body.data.length > 0) {
              //   for (let [key, value] of Object.entries(data.body.data[0])) {
              //     if (value !== null && value !== undefined && value !== '') {
              //       if (key.includes('_')) {
              //         key = key.replace('_', ' ');
              //       }
              //       headings.push(key);
              //     }
              //   }
              //   data.body.headings = headings;
              // }
            }

            if (request.method !== 'GET') {
              this.notificationsService.showNotifications({
                message: data?.body?.message || 'Action completed successfully',
                severity: 'success',
              });
            }
          }
        },
        error: (error) => {
          this.notificationsService.showNotifications({
            message:
              error?.error?.message ||
              'An error occurred. please try again later!',
            severity: 'error',
          });

          if (
            error?.status == 401 &&
            error?.error?.message.includes('is not authorized')
          )
            this.router.navigate(['/auth/login']);
        },
      }),
      finalize(() => {
        this.loaderService.hideLoader({
          route: '',
          type: 'spinner',
        });
      })
    );
  }
}
